import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import PublicLayout from "@/components/layout/PublicLayout";

import Home from "@/pages/Home";
import History from "@/pages/History";
import TownshipBoard from "@/pages/TownshipBoard";
import Postings from "@/pages/Postings";
import { MeetingMinutesList, MeetingMinuteDetail } from "@/pages/MeetingMinutes";
import Calendar from "@/pages/Calendar";
import Projects from "@/pages/Projects";
import Information from "@/pages/Information";
import Links from "@/pages/Links";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import {
  AdminBanner,
  AdminMinutes,
  AdminEvents,
  AdminOfficials,
  AdminProjects,
  AdminNotices,
  AdminLinks,
  AdminGallery,
  AdminPostings,
} from "@/pages/admin/AdminCrudPages";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminChat from "@/pages/admin/AdminChat";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminHome from "@/pages/admin/AdminHome";
import AdminBilling from "@/pages/admin/AdminBilling";

const withPublic = (el) => <PublicLayout>{el}</PublicLayout>;

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={withPublic(<Home />)} />
            <Route path="/history" element={withPublic(<History />)} />
            <Route path="/board" element={withPublic(<TownshipBoard />)} />
            <Route path="/postings" element={withPublic(<Postings />)} />
            <Route path="/minutes" element={withPublic(<MeetingMinutesList />)} />
            <Route path="/minutes/:id" element={withPublic(<MeetingMinuteDetail />)} />
            <Route path="/calendar" element={withPublic(<Calendar />)} />
            <Route path="/projects" element={withPublic(<Projects />)} />
            <Route path="/information" element={withPublic(<Information />)} />
            <Route path="/links" element={withPublic(<Links />)} />
            <Route path="/contact" element={withPublic(<Contact />)} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminOverview />} />
              <Route path="home" element={<AdminHome />} />
              <Route path="banner" element={<AdminBanner />} />
              <Route path="postings" element={<AdminPostings />} />
              <Route path="minutes" element={<AdminMinutes />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="officials" element={<AdminOfficials />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="notices" element={<AdminNotices />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="links" element={<AdminLinks />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="chat" element={<AdminChat />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="audit" element={<AdminAudit />} />
              <Route path="billing" element={<AdminBilling />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
